import React from "react";

const Lettuce = () => {
  return <img src={require("../BurgerAssets/lettuce2.svg")} alt="" />;
};

export default Lettuce;
